import { ProgressIndicatorItem } from 'components/ProgressIndicator';

export const REVIEW_STEP: ProgressIndicatorItem = {
  type: 'single',
  active: false,
};

export const PAID_NO_FINANCE_BASE_STEPS: ProgressIndicatorItem[] = [
  REVIEW_STEP,
  {
    type: 'single',
    active: false,
  },
];

export const STEPS: ProgressIndicatorItem[] = [
  {
    type: 'single',
    active: false,
  },
  {
    type: 'single',
    active: true,
  },
  {
    type: 'single',
    active: false,
  },
];
